module.exports = __webpack_public_path__ + "media/assets/checkbox-check-a7994fcaee2bc7e683e582295d99774d.svg";